import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { GenerateExcelComponent } from './generate-excel.component';
import { MatTooltipModule } from '@angular/material';



@NgModule({
  declarations: [GenerateExcelComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    FormsModule,
    MatTooltipModule
  ],
  entryComponents: [
    GenerateExcelComponent
  ]
})
export class GenerateExcelModule {}
